module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_lg_05.9f1813c3.jpg";